<template>
    <div
        v-if="visible"
        class="bubble"
    >
        <div
            v-for="(message, idx) in messages"
            :key="idx"
            class="bubble__content"
            v-html="message"
        />
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {

    computed: {
        ...mapGetters([
            'messages'
        ]),
        ...{
            visible() {
                return this.messages.length > 0;
            }
        }
    },

};
</script>

<style lang="scss">
@import '../assets/framework';

.bubble {
    position: fixed;
    z-index: 99;
    bottom: $base-padding;
    right: $base-padding;
    display: block;
    max-width: 364px;
    width: calc(100% + 1px);
    background: rgb(0, 120, 212);
    color: white;
    box-shadow: rgba(0, 0, 0, 0.133) 0px 6.4px 14.4px 0px, rgba(0, 0, 0, 0.11) 0px 1.2px 3.6px 0px;
    &__content {
        padding-top: 20px;
        padding-right: 24px;
        padding-bottom: 20px;
        padding-left: 24px;
    }
}
</style>
